export default __webpack_public_path__ + "static/media/rocket_anim_112.70d7dd58.png";